export enum ErrorMessage {
  UnknownError = 'Something went wrong, please refresh the page or try again later',
}
